<template>
<form @submit.prevent="formSubmit" id="form-gotopage" class="text-center" method="get">
    <div class="input-group w-auto mx-auto mt-4">
        <label for="gotopage" class="my-1 me-2 text-secondary">Go to page</label>
        <input v-model="page" @keyup="checkInput" type="text" name="page" id="gotopage" size="4" class="form-control bg-light rounded data-hj-allow" aria-label="Go to page" aria-describedby="button-gotopage">
        <input v-if="query" v-model="query" type="hidden" name="q" id="querystring">
        <input v-if="years" v-model="years" type="hidden" name="years" id="yearstring">
        <input v-if="tags" v-model="tags" type="hidden" name="tags" id="tagstring">
        <input v-if="rarity" v-model="rarity" type="hidden" name="rarity" id="raritystring">
        <input v-if="sort" v-model="sort" type="hidden" name="sort" id="sortstring">
        <button class="btn btn-outline-secondary" type="submit" id="button-gotopage">GO</button>
    </div>
</form>
</template>

<script>
export default {
    name: "GoToPage",
    props: ['pages', 'search', 'years', 'tags', 'rarity', 'sort'],
    data() {
        return {
            page: '',
            query: this.search,
            totalPages: this.pages
        }
    },
    computed: {
        //
    },
    methods: {
        checkInput: function(e) {
            e.target.setCustomValidity('');
            e.target.classList.remove('is-invalid');

            if (this.page !== '' && (Number(this.page) < 1 || Number(this.page) > Number(this.totalPages) || isNaN(this.page))) {
                e.target.setCustomValidity('invalid');
                e.target.classList.add('is-invalid');
            }
        },
        formSubmit: function (e) {
            let el = document.getElementById('gotopage');
            if (this.page && el.checkValidity()) {
                e.target.submit();
            } else {
                el.setCustomValidity('invalid')
                el.classList.add('is-invalid');
            }
        }
    }
}
</script>